import React from 'react';
import './HomepageHeader.css';

const HomepageHeader = () => {
  return (
    <header className="homepage-header">
      {/* Desktop Version */}
      <div className="homepage-header__background homepage-header__desktop">
        <div className="homepage-header__content">
          <div className="homepage-header__text">
            <p className="homepage-header__subtitle">Strategisch. Unternehmerisch. Persönlich.</p>
            <h1 className="homepage-header__title">
              Nintschew & Partner - <br />
              <span className="homepage-header__title--highlight">Boutique-Steuerberatung</span> <br />
              für Unternehmer und <br />
              Investoren.
            </h1>
            <a href="#contact-form" className="homepage-header__cta">
              Anfrage senden
            </a>
          </div>
        </div>
      </div>

      {/* Mobile Version */}
      <div className="homepage-header__mobile">
        <div className="homepage-header__mobile-image">
          <img
            src="/img/nintschew_partner_mobile_neu_3.jpg"
            alt="Nintschew & Partner"
            className="homepage-header__mobile-img"
          />
          <div className="homepage-header__mobile-logo">
            <img
              src="/img/nintschew_logo_2.png"
              alt="Nintschew & Partner Logo"
              className="homepage-header__mobile-logo-image"
            />
          </div>
        </div>
        
        <div className="homepage-header__mobile-content">
          <div className="homepage-header__text">
            <p className="homepage-header__subtitle">Strategisch. Unternehmerisch. Persönlich.</p>
            <h1 className="homepage-header__title">
              Nintschew & Partner - <br />
              <span className="homepage-header__title--highlight">Boutique-Steuerberatung</span> <br />
              für Unternehmer und <br />
              Investoren.
            </h1>
            <a href="#contact-form" className="homepage-header__cta">
              Anfrage senden
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default HomepageHeader;
